export function Card({ title, titleId, children, footer, tone }) {
  const className = tone ? `card card-tone-${tone}` : 'card';
  return (
    <section className={className} aria-labelledby={titleId}>
      {title ? (
        <h2 id={titleId} className="card-title">{title}</h2>
      ) : null}
      {children}
      {footer ? <div className="card-footer">{footer}</div> : null}
    </section>
  );
}
